import React from "react";
import "./Header.css";
import { NavLink } from "react-router-dom";
import Routes from "Components/Routes";

function Header() {
  return (
    <header>
      <nav className="navbar navbar-expand navbar-dark site-width m-auto">
        <NavLink exact to={Routes.home} className="navbar-brand roboto-condenced text-uppercase">
          <img src="/img/logo.png" className="pb-1" width="25" height="28" alt="" /> DNS Checker
        </NavLink>
        <div className="navbar-nav">
          <NavLink exact to={Routes.home} className="nav-item nav-link roboto-condenced text-uppercase">
            Home
          </NavLink>
          <a className="nav-item nav-link roboto-condenced text-uppercase" href="https://totalbits.com">
            Tools
          </a>
          <NavLink exact to={Routes.contact} className="nav-item nav-link roboto-condenced text-uppercase">
            Contact Us
          </NavLink>
        </div>
      </nav>
    </header>
  );
}

export default Header;
